import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76829108"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "user-menu mb-5",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_2 = {
  class: "cursor-pointer d-flex align-items-center symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_3 = { class: "symbol symbol-size" }
const _hoisted_4 = { class: "symbol-label symbol-name" }
const _hoisted_5 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "current-name d-flex align-items-center fs-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.UserNameInitial), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentUser.name), 1)
        ])
      ])
    ]),
    _createVNode(_component_KTUserMenu)
  ]))
}